import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[remote-func]',
    standalone: false
})
export class RemoteFuncDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}